import { TRANSITION_DURATION, TRANSITION_TIMING, TRANSITION_TYPES } from "../constants";
const transitionString = (target, duration, timing, delay) => `${target} ${duration} ${timing} ${delay}`;
const transitionPresets = {
    [TRANSITION_TYPES.base]: (target, delay) => transitionString(target, `${TRANSITION_DURATION.base}ms`, TRANSITION_TIMING.base, delay),
    [TRANSITION_TYPES.ease]: (target, delay) => transitionString(target, `${TRANSITION_DURATION.base}ms`, TRANSITION_TIMING.ease, delay),
    [TRANSITION_TYPES.slow]: (target, delay) => transitionString(target, `${TRANSITION_DURATION.slow}ms`, TRANSITION_TIMING.base, delay),
    [TRANSITION_TYPES.slowEase]: (target, delay) => transitionString(target, `${TRANSITION_DURATION.slow}ms`, TRANSITION_TIMING.ease, delay)
};
export function transition(preset = "base", target = "all", delay = "0s") {
    return transitionPresets[preset](target, delay);
}
transition.timing = (key = "base") => TRANSITION_TIMING[key];
transition.duration = (key = "base", includeUnit = true) => includeUnit ? `${TRANSITION_DURATION[key]}ms` : TRANSITION_DURATION[key];
